import { EmailSettingsLayout } from './components';
import { AccountVerificationContent } from './account-verification-content';

export default function AccountVerificationPage() {
  return (
    <EmailSettingsLayout title="Account Verification">
      <AccountVerificationContent />
    </EmailSettingsLayout>
  );
}
